export const beforeItems: string[] = [
  'Chercher des activités éparpillées',
  'Réécrire les consignes',
  'Fabriquer les supports',
  'Prévoir les variantes au dernier moment',
  'Construire chaque grille d’observation',
]

export const afterItems: string[] = [
  'Une collection organisée',
  'Des activités et supports élèves',
  'Des repères pour adapter la difficulté',
  'Cinq dossiers complémentaires',
  'Des corrigés et critères d’observation',
]

export const transformationStats: { value: string; label: string }[] = [
  { value: '10 tomes', label: 'Une progression par compétences' },
  { value: '5 bonus', label: 'Des outils pour le quotidien' },
  { value: 'Français', label: 'Une collection internationale adaptable' },
]
